document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.offers-bar');
  if (!section) return;

  const modal = section.querySelector('[data-offers-modal]');
  const closeBtn = section.querySelector('[data-offers-close]');
  const triggers = section.querySelectorAll('[data-offers-trigger]');

  if (!modal || !closeBtn) return;

  let lastTrigger = null;

  const openModal = (event) => {
    lastTrigger = event.currentTarget;
    const scrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = `-${scrollY}px`;
    modal.showModal();
    document.body.classList.add('offers-bar-open');
  };

  const closeModal = () => {
    const scrollY = parseInt(document.body.style.top || '0') * -1;
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
    modal.close();
    document.body.classList.remove('offers-bar-open');
    lastTrigger?.focus();
  };

  triggers.forEach((trigger) => trigger.addEventListener('click', openModal));
  closeBtn.addEventListener('click', closeModal);

  modal.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeModal();
  });

  modal.addEventListener('click', (event) => {
    if (event.target === modal) closeModal();
  });

  section.querySelectorAll('[data-copy-code]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const { copyCode } = btn.dataset;
      if (!copyCode) return;

      navigator.clipboard.writeText(copyCode).then(() => {
        btn.setAttribute('data-copied', '');
        setTimeout(() => btn.removeAttribute('data-copied'), 3000);
      }).catch(() => {});
    });
  });
});
